/* eslint-disable implicit-arrow-linebreak */
import * as React from 'react'
import SocialNetworksData from '../SocialNetworks/SocialNetworksData'
import styled from 'styled-components'

const SocialNetworksWrapper = styled.ul`
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;

  @media (min-width: 992px) {
    align-items: center;
    height: 100%;
  }
`

const ListText = styled.li`
  width: 100%;
  margin-right: 0;

  @media (min-width: 992px) {
    width: auto;
    margin-right: 32px;
  }

  p {
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: -.2px;
    line-height: 1.5;
    text-align: center;

    @media (min-width: 992px) {
      margin-bottom: 0;
    }
  }

  span {
    text-transform: uppercase;
  }
`

const ListIcons = styled.li`
  margin-right: 37px;

  a {
    color: #fff;

    .newsletter-icon {
      height: 23px;
      max-width: 100%;
    }
  }
`

const Icon = styled.img`
  height: 23px;
`

const { title, titleSpan, items } = SocialNetworksData
const SocialNetworks = () => {
  return (
    <div>
      <SocialNetworksWrapper>
        <ListText>
          <p data-testid="text">
            {title} <span>{titleSpan}</span>
          </p>
        </ListText>
        { items.map( ( icon ) =>
          <ListIcons
            key={ icon.id }
          >
            <a
              href={ icon.url }
            >
              <Icon
                alt={ icon.alt }
                loading="lazy"
                src={ icon.src }
              />
            </a>
          </ListIcons> ) }
      </SocialNetworksWrapper>
    </div>
  )
}

export default SocialNetworks
